import "./index.scss";
import React, { useState, useRef } from "react";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import PDFViewer from "../PDFViewer/PDFviewer";
import { DataTable } from "primereact/datatable";
import downloadIcon from "../../../assets/images/downloadIcon.svg";
import downloadPdfIcon from "../../../assets/images/downloadPdfIcon.svg";
import { downloadAzureContainer } from "../../../apis/downloadAzureContainer";
import { Toast } from "primereact/toast";
import { toastMessages, showToast } from "../../../utils";
const Versionhistory = ({
  onHide,
  RowData,
  fileList,
  headerName,
  JobListData,
  ViewModalPDF,
  ProjectDetalis,
  showVersionList,
}) => {
  const versionHistoryColumns = [
    { header: "Version", field: "Version" },
    { header: "Filename", field: "Filename" },
    { header: "Owner", field: "Owner" },
    { header: "Date", field: "Date" },
  ];
  const [path, setPath] = useState("");
  const [ViewPdf, setViewPdf] = useState(false);
  const uniqueFileList = fileList.filter(
    (item, index, self) =>
      index === self.findIndex((t) => t.Version === item.Version && t.Filename === item.Filename)
  );
  const toast = useRef(null);
  //3234 -A toast message has been added to inform the user about the download status, as the download API takes more time to complete.
  const downloadPdf = async (event, el) => {
    event.preventDefault();
    const Version = el?.Version;
    const FileGroup = el?.FileGroup;
    const fileName = el?.Filename;
    const filteredChildren = JobListData.filter((el) => el.key === RowData.parentKey);

    // Fetching required data
    const JobId = filteredChildren?.[0]?.children.find((el) => el.key === RowData.keyCode)?.data
      ?.JobID;
    const GroupName = filteredChildren?.[0]?.children.find((el) => el.key === RowData.keyCode)?.data
      ?.Filename;
    const Subfolder = filteredChildren?.[0]?.data?.Folder;

    // Parent and child task id for custom fullkit only
    const fileObj = searchFile(el?.FileID, filteredChildren?.[0]?.children);
    const parentTaskId = fileObj?.ParentTaskId;
    const childTaskId = fileObj?.AWMTaskID;

    const filePath = el?.Filepath;
    const targetFolders = ["TechSpecXML", "CICMappingXML", "TD", "TasKXML", "XFDF"];
    const isXfdfFile = fileName?.toLowerCase().endsWith(".xfdf");
    const matchedFolder =
      targetFolders.find((folder) => new RegExp(`\\b${folder}\\b`, "i").test(filePath)) || "";
    const finalFolder = isXfdfFile ? "XFDF" : matchedFolder;

    // Dynamically append the folder path if condition matches
    const basePath = Subfolder === "AdditionalFiles"
      ? `${ProjectDetalis?.ProjectID?.toUpperCase()}/${Subfolder}`
      : `${ProjectDetalis?.BU}/${ProjectDetalis?.Region}/${ProjectDetalis?.ProjectID?.toUpperCase()}/${Subfolder}`;
    const jobIdentifier =
      Subfolder === "CPPFA" ? Subfolder : Subfolder === "GA Brief" ? GroupName : JobId;

    let folderPath;
    if (Subfolder === "Custom Fullkit") {
      folderPath = `${parentTaskId}/${childTaskId}/${Version}`;
    } else if (Subfolder === "AdditionalFiles") {
      folderPath = `${Version}`;
    } else if (FileGroup) {
      folderPath = `${jobIdentifier}/${FileGroup}/${Version}`;
    } else if (finalFolder) {
      folderPath = `${jobIdentifier}/${finalFolder}/${Version}`;
    } else {
      folderPath = `${jobIdentifier}/${Version}`;
    }

    const dynamicPath = `${basePath}/${folderPath}/`;

    // Show the "Please wait" toast message using the toastMessages object
    showToast(toast, "warn", toastMessages.downloading.detail, { sticky: true });

    try {
      // api call
      if (RowData?.data?.Company) {
        //3504 fixed to fix download issue
        // Check if company name exists
        const copyXmlFolder = `${RowData?.data?.Company}/Outbound/RTA_CopyXML`;

        // Download the file for CopyXmlData using fileUrl
        await downloadAzureContainer(fileName, copyXmlFolder);
      } else {
        await downloadAzureContainer(fileName, dynamicPath);
      }

      // Show success toast once download is complete
      showToast(toast, "success", toastMessages.downloadComplete.detail, {
        life: 3000,
        clearPrevious: true,
      });
    } catch (error) {
      // Show error toast if the download fails
      showToast(toast, "error", toastMessages.downloadFailed.detail, {
        life: 3000,
        clearPrevious: true,
      });
    }
  };

  const searchFile = (fileId, filteredChildrenArr) => {
    let fileInfo = null;
    if (filteredChildrenArr) {
      filteredChildrenArr?.forEach((parentTask) => {
        parentTask?.children?.forEach((childTask) => {
          childTask?.children?.forEach((file) => {
            if (fileId === file.data.FileID) {
              fileInfo = file.data;
            }
          });
        });
      });
      return fileInfo;
    }
  };

  const viewPdf = (options, ViewPFURL) => {
    setViewPdf(true);
    setPath(ViewPFURL);
  };
  return (
    <div>
      <Toast ref={toast} />
      <Dialog
        headerClassName="version-history-dialog-header"
        className="version-history-dialog"
        visible={showVersionList}
        style={{ width: "75vw" }}
        header={headerName}
        onHide={onHide}
        maximizable
      >
        <div>
          <DataTable value={uniqueFileList} scrollable scrollHeight="400px">
            {versionHistoryColumns?.map((el) => (
              <Column header={el?.header} field={el?.field} />
            ))}
            <Column
              header="Action"
              body={(el) => {
                return (
                  <div className="flex-display">
                    <img
                      src={downloadIcon}
                      alt="downloadicon"
                      className="download_icon"
                      onClick={(e) => downloadPdf(e, el)}
                    />
                    {ViewModalPDF && (
                      <img
                        alt="downloadpdficon"
                        src={downloadPdfIcon}
                        className="view_pdf_icon"
                        onClick={() => viewPdf(el, el?.ViewPFURL)}
                      />
                    )}
                  </div>
                );
              }}
            ></Column>
          </DataTable>
        </div>
      </Dialog>

      <Dialog
        headerClassName="version-history-dialog-header"
        className="version-history-dialog"
        onHide={() => setViewPdf(false)}
        style={{ width: "80vw" }}
        header={headerName}
        visible={ViewPdf}
        maximizable
      >
        {/* changed from PDFViewer to iframe: AWM-3478 */}
        {/* <div>
          <PDFViewer path={path} width={"100%"} height={"600px"} />
        </div> */}
        <iframe src={path} title="File Content" style={{ width: "100%", height: "500px" }} />
      </Dialog>
    </div>
  );
};
export default Versionhistory;
